import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Spin, message } from 'antd'
import Icon from '../icon'
import request from '../../utils/request'
import './tagSelection.less'

const API = {
  ALL_DATA: 'zhikuan/img-tag/list-tag',
  HISTORY_DATA: 'zhikuan/img-tag/user-record-list',
  DELETE_HISTORY: 'zhikuan/img-tag/delete-use-record'
}
const MAX_LENGTH = 20
let timeoutId = 0
export default function TagListHistory({ onAdd, onDelete, visible, keyword, setKeyword, smartTags, showSmartTags, value = [], setSearchData: setParentSearchData }) {
  const [searchData, setSearchData] = useState([])
  const [loading, setLoading] = useState(false)
  const [historyData, setHistoryData] = useState([])
  useEffect(() => {
    actions.fetchHistoryData()
  }, [visible])
  useEffect(() => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      actions.fetchSearchResult(keyword)
    }, 600)
  }, [keyword])
  const actions = {
    async fetchSearchResult(_keyword) {
      setLoading(true)
      if (!_keyword) {
        setSearchData([])
        return
      }
      const result = await request.spost(API.ALL_DATA, { pageSize: 30, rankStatus: 1, keyWords: _keyword }, 'tag-history')
      const searchResults = result.resultList || []
      setSearchData(searchResults)
      // 将搜索结果传递给父组件
      if (setParentSearchData) {
        setParentSearchData(searchResults)
      }
      setLoading(false)
    },
    async fetchHistoryData() {
      const result = await request.sget(API.HISTORY_DATA)
      setHistoryData(result)
    },
    async clearHistoryData() {
      await request.post(API.DELETE_HISTORY, {})
      setHistoryData([])
    },
  }
  const events = {
    onKeyDown(e) {
      if (e.keyCode === 13) {
        events.onClickSearchItem(e.target.value)
      }
    },
    onClearItems() {
      actions.clearHistoryData()
    },
    onChange(e) {
      if (e.target.value.length >= MAX_LENGTH) {
        message.error(`单个标签字数不可超过${MAX_LENGTH}字哦～`)
        return
      }
      setLoading(!!e.target.value)
      setKeyword(e.target.value)
    },
    onClickSearchItem(tagName, tagId = null) {
      setKeyword('')
      events.onClickItem(tagName, tagId)
    },
    onClickItem(tagName, tagId = null) {
      if (value.some(t => t.label === tagName)) {
        // 执行删除操作
        onDelete?.(tagName)
        return
      }
      // 添加操作
      onAdd?.(tagName, tagId)
    }
  }
  const renderer = {
    listMap(m) {
      return <li
        key={m.tagId}
        className={classNames({ active: value.some(t => t.label === m.tagName) })}
        onClick={() => events.onClickItem(m.tagName, m.tagId)}
      >{m.tagName}</li>
    },
    smartListMap(m) {
      return <li
        key={m.tag}
        className={classNames({ active: value.some(t => t.label === m.tag) })}
        onClick={() => events.onClickItem(m.tag)}
      >{m.tag}</li>
    },
    searchList() {
      return searchData.map(item => (
        <li
          key={item.tagId}
          className={classNames({ active: value.some(t => t.value === item.tagId) })}
          onClick={() => events.onClickSearchItem(item.tagName, item.tagId)}
        >
          {`${item.createUser}-${item.tagName}`}
        </li>
      ))
    }
  }
  return ((searchData?.length || historyData?.length || showSmartTags?.length) ? <div className="mn-tag-list-history">
    {!!keyword.length && <Spin spinning={loading} indicator={<Icon type="m-jiazaizhong" spin />}><ul className="items">
      {renderer.searchList()}
    </ul>
    </Spin>}
    {!keyword.length && <>
      {historyData?.length > 0 && <div className="recently-used-container">
        <div className="mini-header">
          <span>最近使用</span><a className="clear" onClick={() => events.onClearItems()}>清除记录</a>
        </div>
        <ul className="items">
          {historyData.map(renderer.listMap)}
        </ul>
      </div>}
      {showSmartTags?.length > 0 && <div className="smart-tags-container">
        <div className="mini-header">
          <span>智能标签</span>
        </div>
        <ul className="items">
          {
            Object.keys(smartTags).filter(m => smartTags[m]).map((ele) => {
              return smartTags[ele].map(renderer.smartListMap)
            })
          }
        </ul>
      </div>}
    </>}
  </div> : null)
}
